export default {
  'TAG' (state) {
    return state.tag
  },
  'TAGS' (state) {
    return state.tags
  }
}
